import { useTranslation } from "@/hooks";
import { useProjects } from "@/stores/database";
import { useUIStore } from "@/stores/ui";
import type { Project } from "@/types/stores/database";
import { ActionIcon, Button, Flex, Text, Tooltip } from "@mantine/core";
import { IconFolder, IconPlus } from "@tabler/icons-react";
import { Link, Outlet, useParams } from "react-router";
import "./ProjectsLayout.css";

export function ProjectsLayout() {
  const { t } = useTranslation();
  const projects = useProjects();
  const openModal = useUIStore((state) => state.openModal);
  const { projectId } = useParams();

  const isActive = (id: string) => projectId == id;

  return (
    <Flex direction="row" h="100%" w="100%">
      <nav className="projects-nav">
        <Flex px="md" justify="space-between" align="center">
          <Text fw={600} fz={16}>
            {t("projects").myProjects}
          </Text>
          <Tooltip label={t("projects").createNewProject} position="top" withArrow>
            <ActionIcon
              variant="subtle"
              size="lg"
              onClick={() => openModal(undefined, "project")}
            >
              <IconPlus stroke={2} size={18} />
            </ActionIcon>
          </Tooltip>
        </Flex>
        <Flex direction="column">
          {projects.map((project) => (
            <ProjectLink
              key={project.id}
              project={project}
              isActive={isActive(project.id)}
            />
          ))}
        </Flex>
      </nav>
      <main className="projects-main">
        <Outlet />
      </main>
    </Flex>
  );
}

function ProjectLink({
  project,
  isActive,
}: {
  project: Project;
  isActive: boolean;
}) {
  return (
    <Link to={`/build/${project.id}`} key={project.id}>
      <Button
        c="dark.9"
        size="lg"
        justify="flex-start"
        variant={isActive ? "light" : "white"}
        fullWidth
        leftSection={
          <IconFolder
            color={isActive ? "var(--mantine-color-eu_flag-filled)" : undefined}
            size={20}
          />
        }
      >
        <Text fz={16}>{project.title}</Text>
      </Button>
    </Link>
  );
}
